export const deliveryState = {
  pickup: {
    date: "",
    time: "",
    type: "",
    firstname: "",
    lastname: "",
    phone: "",
    address: "",
    save: true,
  },
  dropoff: {
    date: "",
    time: "",
    type: "",
    firstname: "",
    lastname: "",
    phone: "",
    address: "",
    save: true,
    stop: [],
  },
  package: {
    type: "",
    numberOfPackage: "",
    details: "",
    weight: "",
    fragile: "",
    height: "",
    length: "",
    width: "",
    image: "",
  },
  payment: {
    service: {
      id:"",
      name: "select plan",
      description: "",
      price: 0,
      type: "",
    },
    coupon:"",
    type: "",
    price:0
  },
};

export const dropDownData = {
  pickup_type: ['Residential', 'Office'],
  places:[],
  dropoff_type: ['Residential', 'Office'],
  package_type: [ 'Parcel','Box'],
  fragile_type: ["Yes", "No"],
  delivery_service: [{}],
  payment_type: [],
};

export const deliveryPaneDisplay = {
  pickup:false,
  dropoff:false,
  package:false,
  payment:false,
};
